import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { WelletContext } from '../../../context/WelletContext';
import { getCookie } from '../../../helpers/cookie';
import ContentApp from '../../../components/ContentApp';
import EventGallery from '../../../components/EventGallery/EventGallery';
import ChevronIcon from '../../../components/icons/chevronIcon';
import { fetchShow } from '../../../actions/appActions';
import VenueGallery from '../../../components/VenueGallery/VenueGallery';
import BalanceConsumer from '../../../components/Consumer/Balance/BalanceConsumer';
import DigitalCard from '../../../components/Consumer/DigitalCard/DigitalCard';
import ContainerEventsDetails from '../../../components/CardEventsDetails/ContainerEventsDetails';
import AccountHeaderConsumer from '../../../components/HeaderConsumer/HeaderConsumer';
import { useTranslation } from 'react-i18next';
import styles from './EventCustomer.module.css';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import NavSelector from '../../../components/NavSelector/NavSelector';

const Home = ({ history }) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const user = useSelector((state) => state.associates.user);
  const language = useSelector((state) => state.app.language);
  const [events, setEvents] = useState([]);
  const [venues, setVenues] = useState(null);
  const [eventsTickets, setEventsTickets] = useState([]);
  const cityCookie = getCookie('defaultCity');
  const selectedCity = cityCookie
    ? JSON.parse(cityCookie)
    : { id: null, name: t('allFem'), nameLong: '' };

  const eventsHome = async () => {
    try {
      const response = await welletContext.apis.tickets.post('/reservation/upcoming', {
        limit: 4,
        skip: 0,
        filterDate: 'UPCOMING',
      });
      setEventsTickets(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    eventsHome();
  }, []);

  const getVenues = async () => {
    try {
      const result = await fetchShow(language, selectedCity.id, 1, 100, welletContext, null, null);

      const categorizedVenue = result.shows.reduce((acc, show) => {
        show.categories.forEach((category) => {
          const categoryName = category.name;
          if (!acc[categoryName]) {
            acc[categoryName] = [];
            acc[categoryName].id = category.id;
          }
          acc[categoryName].push({
            ...show,
            priority: category.priority,
          });
        });
        return acc;
      }, {});

      for (const category in categorizedVenue) {
        categorizedVenue[category].sort((a, b) => a.priority - b.priority);
      }

      setVenues(Object.entries(categorizedVenue));
    } catch (error) {
      console.error(error);
    }
  };

  const getEvents = async () => {
    try {
      const response = await welletContext.apis.tickets.get('/shows/events', {
        params: {
          cityId: selectedCity.id,
          take: 20,
        },
      });
      setEvents(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getEvents();
    getVenues();
  }, []);

  return (
    <>
      <AccountHeaderConsumer
        title={
          <div
            className={`text-white font-medium ${styles.cityContainer}`}
            onClick={() => history.push(`/city-selector?events=/`)}
          >
            {selectedCity?.name} <ChevronIcon size='15' color='#fff' rotation={90} />
          </div>
        }
      />

      <div>
        <ContentApp menu header>
          <div className='mt-2'>
            <BalanceConsumer points={user.currentLoyalty.points} organization={user.company.name} />
          </div>
          <div className='mt-2'>
            <DigitalCard name={user.name} category={user.currentLoyalty.category} />
          </div>

          <ContainerEventsDetails events={eventsTickets} />

          {events.length > 0 && (
            <div className='mt-4'>
              <div className='row'>
                <div className='col fw-bold'>{t('nextEvents')}</div>
                <div className='col-auto text-tertiary font-tiny my-auto'>
                  <Link to={'/events'} className='text-secondary'>
                    {t('viewAll')}
                  </Link>
                </div>
              </div>
              <div className='mt-3'>
                <EventGallery events={events} lng={language} />
              </div>
            </div>
          )}

          {venues &&
            venues.map((item) => (
              <div className='mt-5' key={item[0]}>
                <div className='row'>
                  <div className='col fw-bold'>{item[0]}</div>
                  <div className='col-auto text-tertiary font-tiny my-auto'>
                    <Link to={`/restaurant-list?category=${item[1].id}`} className='text-secondary'>
                      {t('viewAll')}
                    </Link>
                  </div>
                </div>

                <div className='mt-3'>
                  <VenueGallery venues={item[1]} />
                </div>
              </div>
            ))}
        </ContentApp>
        <NavSelector history={history} />
      </div>
    </>
  );
};

export default Home;
